<div class="order-card-container">
  <div
    class="visual-builder-block"
    [class.selected]="selectedId?.id?.includes('orderStatus')"
    (click)="selectItemBlock('orderStatus', $event)"
  >
    <div
      class="order-status"
      *ngIf="orderStatusOn"
      [ngStyle]="orderStatus | fontFamily | assign : orderStatusStyles"
      [innerHTML]="order.status"
    ></div>
  </div>
  <div
    class="visual-builder-block"
    [class.selected]="selectedId?.id?.includes('orderNumber')"
    (click)="selectItemBlock('orderNumber', $event)"
  >
    <div
      *ngIf="orderNumberOn"
      class="order-number"
      [ngStyle]="orderNumber | fontFamily | assign : orderNumberStyles"
    >
      {{ order.number }}
    </div>
  </div>
  <div
    class="visual-builder-block"
    [class.selected]="selectedId?.id?.includes('orderLastUpdated')"
    (click)="selectItemBlock('orderLastUpdated', $event)"
  >
    <div
      *ngIf="orderLastUpdatedOn"
      class="order-last-updated"
      [ngStyle]="
        orderLastUpdated | fontFamily | assign : orderLastUpdatedStyles
      "
    >
      <span>{{ 'last_updated' | translate }}:</span>
      {{ order.lastUpdated | dateFormat : 'yyyy-MM-dd hh:mm' }}
    </div>
  </div>
</div>
<div class="pb-5" *ngIf="order.orderItems?.length && orderItemsFrame?.on">
  <div
    class="visual-builder-block"
    [class.selected]="selectedId?.id?.includes('notYetShippedItemsTitle')"
    (click)="selectItemBlock('notYetShippedItemsTitle', $event)"
  >
    <div
      [ngStyle]="
        notYetShippedItemsTitle
          | fontFamily
          | assign : notYetShippedItemsTitleStyle
      "
      class="not-yet-fulfilled"
    >
      {{ 'tp_not_yet_fulfilled' | translate }}
    </div>
  </div>
  <app-tracking-page-order-items-frame
    [itemsFrame]="orderItemsFrame"
    [items]="order.orderItems"
    [itemsOpened]="true"
    (selectBlock)="selectBlock.emit($event)"
    [selectedId]="selectedId"
  ></app-tracking-page-order-items-frame>
</div>
